import { useShallow } from 'zustand/react/shallow';

import { useMessagesStore } from '@/store/messages.store';
import TextArea from '@ingka/text-area';
import { translate } from '@repo/phrase';
import { MessageBanner, type MessageBannerState } from '@repo/ui/messages';
import type { MutationStatus } from '@tanstack/react-query';

interface Props {
    bannerState: MessageBannerState;
    status: MutationStatus;
}
export const AssetMessageModalEdit = ({ bannerState, status }: Props) => {
    const { draftMessage, setDraftMessage } = useMessagesStore(
        useShallow((state) => ({
            draftMessage: state.draftMessage,
            setDraftMessage: state.setDraftMessage,
        }))
    );
    return (
        <>
            <TextArea
                id="edit-message-textarea"
                data-testid="edit-message-textarea"
                label={translate('messages_modal_edit_message_label')}
                value={draftMessage}
                onChange={(e) => {
                    setDraftMessage(e.target.value);
                }}
            />
            {status === 'error' && <MessageBanner state={bannerState} translate={translate} />}
        </>
    );
};
